import {Component, OnInit} from '@angular/core';
import {DocumentCategoryService} from "../../../../service/repository/document-category.service";
import {DocumentCategoryView} from "../../../../domain/documentCategoryView";
import {GlobalAppService} from "../../../../../core/commons/global-app.service";

@Component({
    selector: 'category-explorer',
    templateUrl: './category-explorer.component.html',
    styleUrls: ['./category-explorer.component.scss'],
})
export class CategoryExplorerComponent implements OnInit {

    categories : DocumentCategoryView[] = [];
    showHiddenFolders : boolean = false;
    showCategoryForm : boolean = false;

    constructor(private categoryService : DocumentCategoryService,
                private messageService : GlobalAppService) {
    }

    ngOnInit() {

        if ( this.categoryService.authService.isLoggedIn() ){
            this.categoryService.authService.user.subscribe(u => {
                this.showHiddenFolders = u.hasFx("Category.CHANGECATEGORYVISIBILITY") || u.hasFx("Document.CREATE");
            })
        }

        this.categoryService.parentCategories.asObservable()
            .filter( categories => categories != null)
            .subscribe(categories => {
                this.categories = categories;
            });

        this.categoryService.getParentCategories();
    }


    public createParentCategory() : void {
        this.showCategoryForm = true;
    }

    public refreshFolders( e ) : void {
        this.categoryService.getParentCategories();
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/repository/explorer/category-explorer/category-explorer.component.ts